import { Button } from "../../../../../components/button/Button"
import { withClassName } from "../../../../../utils/reactHelpers/withClassName"

export const MainButton = withClassName("block mt-3.5 mb-2", Button)
